<template>
	<div class="taggable_multiple_select grid-item c_selector">
		<v-select
			:options="item.keyRange"
			:filterable="true"
			:multiple="true"
			:get-option-label="option =>option.trans ? `${this.$t(option.trans)}` : option.title"
			:key="item.index"
			v-model="item.values"
      :filterBy="handleVSelectFilterBy"
      :disabled="item.disabled"
		>
      <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
    </v-select>
	</div>
</template>
<script>
export default {
  name: 'TaggableMultipleSelect',
  props: ['item'],
  updated() {
    try {
      for (const element of document.getElementsByClassName('vs__deselect')) {
        element.title = "";
      }
    } catch (e) {

    }
  },
  methods: {
    handleVSelectFilterBy(option, label, search) {
      try {
        return this.item?.filterBy ?
            this.item?.filterBy(option, label, search) :
            (`${label}`).toLowerCase().includes(search.toLowerCase());
      } catch (e) {
        return (`${label}`).toLowerCase().includes(search.toLowerCase());
      }
    },
  }
}
</script>
<style lang="scss">
.taggable_multiple_select {
  height: auto;

  .v-select {
    height: auto;
  }

  .vs--disabled{
    div{
      background-color: var(--grey10) !important;
    }
  }

  .vs__dropdown-toggle {
    height: fit-content !important;
    padding: 0.5rem 1rem !important;
    border-radius: 5px !important;

    .vs__selected-options {
      //height: fit-content;
      margin: 0 !important;
      padding: 0 !important;

      .vs__selected {
        margin: 5px !important;
        padding: 0 1em 0 1em !important;
        background-color: var(--white);
        height: 40px !important;
      }
    }
  }
}
</style>